export function register() {
  const btn = document.getElementById("mobile-nav-btn");
  const menu = document.getElementById("mobile-nav-menu");
  if (!btn || !menu) return;

  const header = btn.closest("header");

  btn.addEventListener("click", () => {
    menu.classList.toggle("hidden");
    menu.style.top = header.getBoundingClientRect().bottom + "px";
  });

  menu.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => {
      menu.classList.add("hidden");
    });
  });
}
